<template>
  <aside
    class="fixed top-0 right-0 h-full w-3/4 max-w-sm backdrop-blur-lg bg-base-200/80 text-base-content shadow-2xl z-50 flex flex-col rounded-l-3xl overflow-visible"
    role="dialog"
    aria-modal="true"
    :aria-label="$t('components.header.mobileMenu')">
    <!-- Top bar -->
    <div class="flex items-center justify-between p-4 border-b border-base-300">
      <span class="font-bold text-lg">{{ $t("components.header.menuLabel") }}</span>
      <button @click="emit('toggle-drawer')" :aria-label="$t('components.header.closeMenu')" class="btn btn-ghost">
        ✕
      </button>
    </div>
    <!-- Sticky Language switcher -->
    <LanguageSelect :locale="internalLocale" :alignTop="true" @update:locale="updateLocale" />
  </aside>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import LanguageSelect from "@/components/LanguageSelect.vue";

const props = defineProps<{ locale: string }>();
const emit = defineEmits<{
  (e: "toggle-drawer"): void;
  (e: "update:locale", value: string): void;
}>();

const internalLocale = ref<string>(props.locale);

watch(
  () => props.locale,
  val => {
    internalLocale.value = val;
  }
);

function updateLocale(value: string) {
  internalLocale.value = value;
  emit("update:locale", value);
}
</script>
